import React from "react";
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const faqData = [
  {
    id: "panel1",
    question: "What is transfer pricing?",
    answer:
      "Transfer Pricing refers to cross-border pricing between two associated enterprises. Transactions can include the purchase or sale of goods, lending of money, use of intellectual property, etc.",
  },
  {
    id: "panel2",
    question: "What are associated enterprises?",
    answer:
      "Associated enterprises are simply related enterprises. In the word of law, according to Section 92 of the Income Tax Act, “Associated Enterprise” to another enterprise means an enterprise which participates, directly or indirectly, or through one or more intermediaries, in the management, control, or capital of the other enterprise.",
  },
  {
    id: "panel3",
    question: "When does transfer pricing become relevant to the client?",
    answer:
      "Transfer Pricing is triggered when two associated enterprises enter into any international transaction during the year. This should be analyzed on a case-by-case basis every year.",
  },
  {
    id: "panel4",
    question: "What is the arm’s length price or range?",
    answer:
      "Arm’s length price means the price on which a comparable transaction would have been carried out had it been for two unrelated enterprises.",
  },
];

const FaqSection = () => {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const themeColors = {
    primary: "var(--primary-color)",
    secondary: "var(--secondary-color)",
    midBlue: "#687693",
    lightGray: "#f1f4f9",
    white: "#fff",
  };

  return (
    <Box sx={{ py: 2 }}>
      <Box sx={{ maxWidth: "1200px", margin: "0 auto" }}>
        {faqData.map((faq) => (
          <Accordion
            key={faq.id}
            expanded={expanded === faq.id}
            onChange={handleChange(faq.id)}
            elevation={0}
            sx={{
              marginBottom: "20px",
              borderRadius: "20px !important",
              border: `1px solid #e0e6ed`,
              overflow: "hidden",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              "&:before": { display: "none" },
              "&:hover": {
                borderColor: themeColors.primary,
                boxShadow: `0 10px 30px rgba(26, 66, 161, 0.08)`,
              },
              "&.Mui-expanded": {
                margin: "0 0 24px 0",
                borderColor: themeColors.primary,
                boxShadow: `0 20px 40px rgba(26, 66, 161, 0.12)`,
              },
            }}
          >
            <AccordionSummary
              expandIcon={
                <ExpandMoreIcon sx={{ color: themeColors.primary, fontSize: "28px" }} />
              }
              sx={{
                px: { xs: 2, md: 4 },
                py: 2,
                minHeight: "80px !important",
                bgcolor: '#fff',
                borderLeft: `6px solid transparent`,
                transition: "all 0.3s ease",
                "&.Mui-expanded": {
                  borderLeft: `6px solid ${themeColors.primary}`,
                  bgcolor: 'rgba(26, 66, 161, 0.02)',
                },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 3, width: "100%" }}>
                <Box sx={{ 
                  p: 1.5, 
                  borderRadius: '12px', 
                  bgcolor: 'rgba(26, 66, 161, 0.05)', 
                  color: themeColors.primary,
                  display: { xs: 'none', sm: 'flex' }
                }}>
                  <HelpOutlineIcon sx={{ fontSize: "24px" }} />
                </Box>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: { xs: '1rem', md: '1.2rem' },
                    color: themeColors.primary,
                    fontFamily: "'Roboto Slab', serif",
                  }}
                >
                  {faq.question}
                </Typography>
              </Box>
            </AccordionSummary>

            <AccordionDetails sx={{ px: { xs: 2, md: 5 }, pb: 4, pt: 1 }}>
              <Typography 
                sx={{ 
                  color: themeColors.midBlue, 
                  lineHeight: 1.8, 
                  fontSize: '1.1rem',
                  borderLeft: '4px solid #e0e6ed',
                  pl: 3,
                  py: 1
                }}
              >
                {faq.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
};

export default FaqSection;

